import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchSales } from "../../store/salesSlice"; 
import { DocumentIdName } from "../../services/Enums";
import MyTables from "../MyTable"; 
import FilterInput from "../Filters/FilterInput";
import { 
  TextField, 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  Box 
} from "@mui/material";
import { formatDate } from "../../services/utils";

const DisplaySales = ({ actions, isCommande = false }) => {
  const dispatch = useDispatch();
  const { sales, pagination } = useSelector((state) => state.sale) || {};
  const { selectedShop } = useSelector((state) => state.shop) || {};
  const { selectedMouvement } = useSelector((state) => state.mouvementTypes) || {};

  // State for filters
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    status: "",
    numero: "",
  });

  // Fetch sales data when filters change
  useEffect(() => {
    if ((selectedShop && selectedMouvement) || isCommande) {
      dispatch(fetchSales({ 
        page: 1, 
        limit: 5,
        shop: isCommande ? null : selectedShop?._id,
        mouvementTypes: isCommande ? DocumentIdName.COMMANDE_CLIENT : selectedMouvement?._id,
        ...filters, // Apply filters
      }));
    } else{
    }
  }, [dispatch, selectedMouvement, selectedShop, isCommande, filters]);

  const headers = [
    { key: "date",
      label: "Date",
      render:(row)=> formatDate(row.date)
      },
    { key: "numero", label: "Numero" },
    { key: "status", label: "Status" },
    {
      key: "user",
      label: "User",
      render: (row) => row.user?.login || "N/A",
    },
    {
      key: "clientFournisseur",
      label: "Client",
      render: (row) => row.clientFournisseur?.name || "N/A",
    },
  ];

  const printOptions= {
    title: selectedMouvement?.name,
    paperHeader: {
      
      "Date Range": ` ${filters.startDate} - ${filters.endDate} `,
      "Status": filters.status || "All",
    },
    landscape: true
  }

  const handlePageChange = (newPage, newRowsPerPage) => {
    dispatch(fetchSales({ 
      page: newPage + 1, 
      limit: newRowsPerPage,
      shop: isCommande ? null : selectedShop?._id,
      mouvementTypes: isCommande ? DocumentIdName.COMMANDE_CLIENT : selectedMouvement?._id,
      ...filters, // Apply filters
    }));
  };

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  return (
    <div>
      <h2>
        {isCommande ? "Commande Data" : `Sales Data for: ${selectedShop ? selectedShop.name : "No selected shop"}`}
      </h2>

      {/* Filters */}
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
        <TextField
          type="date"
          label="From Date"
          InputLabelProps={{ shrink: true }}
          value={filters.startDate}
          onChange={(e) => handleFilterChange("startDate", e.target.value)}
        />
        <TextField
          type="date"
          label="To Date"
          InputLabelProps={{ shrink: true }}
          value={filters.endDate}
          onChange={(e) => handleFilterChange("endDate", e.target.value)}
        />
        <FilterInput
          label="Numero"
          filterKey="numero"
          filterValue={filters.numero}
          onFilterChange={(key, value) => handleFilterChange(key, value)}
          size="medium"
          debounceTime={500} 
        />
        <FormControl sx={{ minWidth: 150 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={filters.status}
            onChange={(e) => handleFilterChange("status", e.target.value)}
          >
            <MenuItem value="">All Statuses</MenuItem>
            <MenuItem value="PENDING">Pending</MenuItem>
            <MenuItem value="COMPLETE">Completed</MenuItem>
            <MenuItem value="CANCELED">Cancelled</MenuItem>
            <MenuItem value="IN PROGRESS">In Progress</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <MyTables
        headers={headers}
        totalRows={pagination?.total || 0}
        data={sales}
        actions={actions}
        defaultPageSize={5}
        onPageChange={handlePageChange}
        printOptions={printOptions}
      />
    </div>
  );
};

export default DisplaySales;
